
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { BaseService } from '../../../../services/framework/base.service';
import { ExpertsItem } from '../models/ExpertsItem';


@Injectable({
  providedIn: 'root'
})
export class AskTheExpertService extends BaseService<ExpertsItem> {

  piDomain: string = "";

  constructor(public http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any) {
    super(http, auth);
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
    this.getEndpoint = 'AskTheExperts';

  }


  //public getPILink(userEmail: string, actionUrl: string): Promise<string> {

  //  const url = this.apiUrl + this.getEndpoint + "PISessionKey";

  //  const token = this.getToken();
  //  if (token) {
  //    return this.http.get<ISessionKey>(url, this.getHttpOptions(token)).toPromise().then(data => {
  //      const url = this.piDomain + "/ir/irLogin.aspx?un=" + userEmail + "&SessionKey=" + data.key + "&ReturnUrl=" + actionUrl;
  //      return url;
  //    });
  //  }
  //  else {
  //    return Promise.reject(new Error('No token'));
  //  }
  //}
}





